import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 bg-brand-black overflow-hidden industrial-texture" data-id="element-78">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20 w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10 py-20" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start text-left" data-id="element-80">
          <div className="inline-block border border-brand-accent bg-transparent px-4 py-1.5 rounded-[2px] mb-8" data-id="element-81">
            <span className="font-heading font-bold text-brand-accent text-xs sm:text-sm uppercase tracking-industrial-wide" data-id="element-82">
              MENTORAT MESERII TEHNICE
            </span>
          </div>

          <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-[48px] leading-[1.15] text-brand-white uppercase tracking-industrial mb-6" data-id="element-83">
            Din nesiguranță și necunoaștere, spre o meserie stabilă și bine
            plătită.
          </h1>

          <p className="font-body text-lg sm:text-xl text-brand-muted leading-relaxed max-w-xl mb-10" data-id="element-84">
            Un program complet de 6 luni pentru bărbații care vor să învețe
            instalații, pipefitting sau sudură TIG de la zero, alături de un
            mentor cu 22 de ani de experiență reală pe șantiere din România și
            Europa.
          </p>

          <div className="flex flex-col items-start gap-4 w-full sm:w-auto" data-id="element-85">
            <a href="https://wa.link/udb2nf" target="_blank" rel="noopener noreferrer" className="inline-block text-center w-full sm:w-auto bg-brand-accent text-brand-black font-heading font-bold uppercase tracking-industrial px-8 py-5 rounded-[4px] hover:bg-white transition-all duration-300 accent-glow-hover" data-id="element-86">
              Programează Sesiunea Gratuită de Mentorat
            </a>
            <p className="font-body text-sm text-brand-dim max-w-md" data-id="element-87">
              Dacă ai încercat singur și nu a mers, nu ești tu problema. Îți
              lipsește un ghid care a trecut deja prin tot.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative h-[500px] lg:h-[700px] w-full rounded-lg overflow-hidden border border-brand-border bg-brand-grey group" data-id="element-88">
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-brand-black/80 via-brand-black/30 to-brand-black/10 group-hover:from-brand-black/60 group-hover:via-brand-black/20 transition-colors duration-500 z-10" data-id="element-89" />

          {/* Real industrial photo — TIG welder at work */}
          <img src="https://cdn.magicpatterns.com/uploads/otREbWCj6RcLspovbRze9j/Screenshot_2026-04-28_at_19.47.45.png" alt="Ionuț Drăgănescu — Mentor Meserii Tehnice" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-90" />

          {/* Decorative elements */}
          <div className="absolute top-4 left-4 w-16 h-16 border-t-2 border-l-2 border-brand-accent/30 z-20" data-id="element-91" />
          <div className="absolute bottom-4 right-4 w-16 h-16 border-b-2 border-r-2 border-brand-accent/30 z-20" data-id="element-92" />

          {/* Bottom caption overlay */}
          <div className="absolute bottom-8 left-8 right-8 z-20" data-id="element-93">
            <div className="inline-block bg-brand-black/70 backdrop-blur-sm px-4 py-2 rounded" data-id="element-94">
              <span className="font-heading font-bold text-brand-accent text-xs uppercase tracking-industrial" data-id="element-95">
                22 ani experiență reală
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}